import * as constants from './constants';

export const initialState = {
  lastRegisteredUsers: [],
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_LAST_USERS_SUCCESS:
    case constants.FETCH_LAST_USERS_FAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default dashboardReducer;
